import React from 'react';
import { AirplaneTakeoffIcon, LoginIcon, CastleIcon, HomeOutlineIcon, TruckDeliveryIcon } from 'mdi-react';
import {UserMenu as CJUserMenu, SideNav, Link, LinkContentWrapper} from '@cjdev/visual-stack-redux/lib/components/SideNav';
import {connect} from 'react-redux';
import {If} from './If';
import {createLogoutRequested, createLoginRequested, userProfileOf, profileRequestedOf, loggedInOf} from '../user';
import {createCoordinatesRequested, HOME_REGION, ACCESS_REGION, DEPLOYMENTS_REGION } from '../navigation';

const LOGGED_IN = 1;
const LOGGED_OUT = 2;
const LOGGING_IN = 3;

const UserMenu = ({loginStatus, userName, userId, requestLogout, requestLogin}) => {
    if (loginStatus === LOGGED_IN) {
        userName = userName || "Profile Unavailable";
        userId = userId || "unavailable";
        const firstInitial = userId.length > 0 ? userId.charAt(0).toUpperCase() : "";
        const lastInitial = userId.length > 1 ? userId.charAt(1).toUpperCase() :  "";
        return <CJUserMenu
            onLogout={ requestLogout }
            firstInitial={ firstInitial }
            lastInitial={ lastInitial }
            label={userName}
        />;
    } else if (loginStatus === LOGGED_OUT) {
        return <div className="sidenav-user-menu">
            <Link >
                <a onClick={requestLogin} >
                    <LinkContentWrapper icon={<LoginIcon />} label="Login" />
                </a>
            </Link>
        </div>;
    } else {
        return null;
    }
};

const ConnectedUserMenu = connect(
    state => {
        const profile = userProfileOf(state);
        let loginStatus = LOGGED_OUT;
        if (loggedInOf(state))
            loginStatus = profileRequestedOf(state) ? LOGGING_IN : LOGGED_IN;
        return {
            loginStatus,
            userId: (profile || {}).emailAddress,
            userName: (profile || {}).name
        };
    },
    dispatch => ({
        requestLogout: () => dispatch(createLogoutRequested()),
        requestLogin: () => dispatch(createLoginRequested())
    })
)(UserMenu);


const Navigation = ({loginStatus, requestHome, requestAccess, requestDeployments}) => {
    return <SideNav
        logo = {(<AirplaneTakeoffIcon style = {{"fill": "#f9f"}} />)}
        appName = "Operations"
        userMenu = {<ConnectedUserMenu />}>
        <Link>
            <a onClick={requestHome} title = "No place like it">
                <LinkContentWrapper icon={<HomeOutlineIcon />} label="Home" />
            </a>
        </Link>
        <If condition = {loginStatus !== LOGGED_OUT}>
            <Link>
                <a onClick={requestDeployments} title = "When it absolutely, positively, has to be there overnight">
                    <LinkContentWrapper icon={<TruckDeliveryIcon />} label="Deployments" />
                </a>
            </Link>
        </If>
        <If condition = {loginStatus !== LOGGED_OUT}>
            <Link>
                <a onClick={requestAccess} title = "Have fun storming the castle!">
                    <LinkContentWrapper icon={<CastleIcon />} label="Access" />
                </a>
            </Link>
        </If>
    </SideNav>;
}

const ConnectedNavigation = connect(
    state => {
        let loginStatus = LOGGED_OUT;
        if (loggedInOf(state))
            loginStatus = profileRequestedOf(state) ? LOGGING_IN : LOGGED_IN;
        return {loginStatus};
    },
    dispatch => ({
        requestHome: () =>  dispatch(createCoordinatesRequested({region: HOME_REGION})),
        requestAccess: () =>  dispatch(createCoordinatesRequested({region: ACCESS_REGION})),
        requestDeployments: () => dispatch(createCoordinatesRequested({region: DEPLOYMENTS_REGION}))
    })
)(Navigation);


export {Navigation, UserMenu, ConnectedUserMenu, ConnectedNavigation }



// WEBPACK FOOTER //
// ./src/view/Navigation.js